import * as qs from 'qs';
import {clearFuelTypes} from '../store/actions/options';
import {API} from './API';

export class FuelTypeService {
  async getTableTypes(params, additional = {}) {
    const [query, page, length] = API.getTableParams(params, additional);
    return this.getTypes(query, page, length);
  }

  async getTypes(query, page, length) {
    return (await API.getConnection())
      .get('fuel-types', {
        params: {...query, ...{page, length}},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => response.data)
      .catch(error => API.handleError(error));
  }

  async saveType(data) {
    let method = 'post';
    let url = 'fuel-types';
    if (data.id) {
      method = 'put';
      url = `${url}/${data.id}`;
    }
    return (await API.getConnection())
      [method](url, data)
      .then(response => {
        API.store.dispatch(clearFuelTypes());
        return response.data.data
      })
      .catch(error => API.handleError(error));
  }
}
